(function($) {

	function marketsInit() {

		var $marketsFilter = $('.jq-markets-filter');

		if ($marketsFilter.length) {

			$marketsFilter.each(function() {

				var $marketFilter = $(this);

				if ($marketFilter.hasClass('is-loaded')) return;

				$marketFilter.addClass('is-loaded');

				$marketFilter
					.find(':input')
					.on('change', function() {
						$marketFilter.submit();
					});

				$marketFilter
					.on('submit', function(event) {
						event.preventDefault();

						if ($().ajaxify) {
							marketsReload($marketFilter, event);
						} else {
							$.getScript(siteConfig.shared + 'jquery.ajaxify.js', function() {
								marketsReload($marketFilter, event);
							});
						}
					});

			});

		}

		var $marketsMap = $('.jq-markets-map');

		if ($marketsMap.length) {

			var marketsMapObserver = new IntersectionObserver(function(entries, observer) {
				$.each(entries, function(entryKey, entry) {
					if (entry.isIntersecting) {
						var $marketMap = $(entry.target);

						if (typeof google === 'object' && google && 'maps' in google){
							marketsMap($marketMap);
						} else {
							$marketMap.addClass('is-in-view');

							$.getScript('//maps.googleapis.com/maps/api/js?key=' + siteConfig.gmapKey + '&callback=marketsMap');
						}

						observer.unobserve(entry.target);
					}
				});
			});

			$('.jq-markets-map').each(function() {
				marketsMapObserver.observe(this);
			});

		}

		var $marketsGallery = $('.jq-market-gallery');

		if ($marketsGallery.length) {

			marketsGalleryState($marketsGallery);

			$(window).on('resize', function() {
				marketsGalleryState($marketsGallery);
			});

		}

	};

	function marketsGalleryState($marketsGallery) {

		$marketsGallery.each(function() {

			var $gallery = $(this);

			var $stage = $gallery.children('.jq-market-gallery-stage');

			var $navLeft = $stage.next('.jq-market-gallery-scroll-left');

			var $navRight = $navLeft.next('.jq-market-gallery-scroll-right');

			var $navs = $navLeft.add($navRight);

			var stageElement = $stage[0];

			var isOverflowing = false;

			$gallery.removeClass('is-overflowing');

			$navs
				.removeAttr('style')
				.off('click.marketGalleryNavigation');

			$stage.off('scroll.marketGallery');

			if (stageElement.scrollWidth > stageElement.clientWidth ||
				stageElement.scrollHeight > stageElement.clientHeight) {

				$gallery.addClass('is-overflowing');

				isOverflowing = true;

			}

			if (isOverflowing) {

				marketsGalleryNavigation($stage);

				$navs.on('click.marketGalleryNavigation', marketsGalleryOnClick);

				$stage.on('scroll.marketGallery', marketsGalleryOnScroll);

			}

		});

	};

	function marketsGalleryOnClick(clickEvent) {

		var $navButton = $(clickEvent.currentTarget);

		var $stage = $navButton.prevAll('.jq-market-gallery-stage');

		var stageElement = $stage[0];

		var stageScroll = {
			top: $stage.scrollTop(),
			left: $stage.scrollLeft(),
			step: {
				x: 60,
				y: 40
			}
		};

		if ($navButton.hasClass('jq-market-gallery-scroll-left')) {

			stageScroll.top -= stageScroll.step.y;
			stageScroll.left -= stageScroll.step.x;

		} else {

			stageScroll.top += stageScroll.step.y;
			stageScroll.left += stageScroll.step.x;

		}

		stageScroll.top = Math.min(Math.max(parseInt(stageScroll.top), 0), stageElement.scrollHeight);

		stageScroll.left = Math.min(Math.max(parseInt(stageScroll.left), 0), stageElement.scrollWidth);

		var stageWrap = $stage[0];
		stageWrap.scrollTo({
			top: stageScroll.top,
			left: stageScroll.left,
			behavior: 'smooth'
		});

		//$stage.scrollTop(stageScroll.top);
		//$stage.scrollLeft(stageScroll.left);


	};

	function marketsGalleryOnScroll(scrollEvent) {

		marketsGalleryNavigation($(scrollEvent.currentTarget));

	};

	function marketsGalleryNavigation($stage) {

		var $navLeft = $stage.next('.jq-market-gallery-scroll-left');

		var $navRight = $navLeft.next('.jq-market-gallery-scroll-right');

		var stageElement = $stage[0];

		var scrollTreshold = 15;

		if ((stageElement.scrollWidth > stageElement.clientWidth &&
			 $stage.scrollLeft() > scrollTreshold) ||
			(stageElement.scrollHeight > stageElement.clientHeight &&
			 $stage.scrollTop() > scrollTreshold)) {

			$navLeft.fadeIn();

		} else {

			$navLeft.fadeOut();

		}

		if ((stageElement.scrollWidth > stageElement.clientWidth &&
			 $stage.width() + $stage.scrollLeft() > stageElement.scrollWidth - scrollTreshold) ||
			(stageElement.scrollHeight > stageElement.clientHeight &&
			 $stage.height() + $stage.scrollTop() > stageElement.scrollHeight - scrollTreshold)) {

			$navRight.fadeOut();

		} else {

			$navRight.fadeIn();

		}

	};
 
	function marketsReload($marketFilter, event) {
		var ajaxRequest = $marketFilter.serialize();

		if ('originalEvent' in event && 'submitter' in event.originalEvent) {
			ajaxRequest += '&' + event.originalEvent.submitter.getAttribute('name') + '=true';
		}

		$.ajaxLink(
			window.location.href,
			{
				history: false,
				refresh: [ '#' + $marketFilter.parents('.jq-markets').attr('id') ],
				onFinish: marketsInit
			},
			document.body,
			'GET',
			ajaxRequest
		);
	};

	function marketsMap($marketMap) {

		if (typeof $marketMap == 'undefined' || $marketMap == '') {

			$marketMap = $('.jq-markets-map.is-in-view');

			$marketMap.removeClass('is-in-view');

		}

		if ($marketMap.hasClass('is-loaded')) return;

		$marketMap.addClass('is-loaded');

		var $markets = $marketMap.parents('.jq-markets');

		var marketMapOptions = $marketMap.data('map-options') || '';

		if (marketMapOptions == '') return;

		marketMapOptions.zoomControlOptions = {
			position: google.maps.ControlPosition.RIGHT_CENTER,
		};

		var marketMap = new google.maps.Map($marketMap[0], marketMapOptions);

		var marketMarkers = [];

		$markets.find('.jq-markets-marker').each(function() {

			var $marketsMarker = $(this);

			if (typeof $marketsMarker.data('marker-position') == 'undefined') return;

			var marketMarkerOptions = {
				position: $marketsMarker.data('marker-position'),
				map: marketMap,
			};

			var marketMarkerContent = $marketsMarker.html();

			var marketMarkerIcon = ($marketsMarker.is('.js-market-not-in-region') && marketMapOptions.region) ? 2 : 0;
			var extraMarketIcon = $marketsMarker.data('extra-icon');
			if($marketsMarker.is('.js-market-not-in-filter')){
				marketMarkerIcon = 2;
			}

			if(marketMarkerIcon!=2 &&  extraMarketIcon !=''){
				marketMarkerOptions.icon =extraMarketIcon;
				marketMarkerOptions.extra_icon =extraMarketIcon;
			}else{
				if ('icons' in marketMapOptions && marketMapOptions.icons[marketMarkerIcon]) {
					marketMarkerOptions.icon = marketMapOptions.icons[marketMarkerIcon];
				}
			}


			var marketMarker = {
				pin: new google.maps.Marker(marketMarkerOptions),
				icon: marketMarkerIcon,
			};

			if (marketMarkerContent != '') {
				marketMarker.window = new google.maps.InfoWindow({
					content: '<div class="' + ($marketsMarker.data('marker-class') || '') + '">' + marketMarkerContent + '</div>',
				});
			}

			marketMarkers.push(marketMarker);

			/*$marketsMarker.css('cursor', 'pointer');

			$marketsMarker.on('click', function() {
				marketMarkerOpen(marketMarker);
			});*/

		});

		marketMarkers.forEach(function(marketMarker) {

			if ('window' in marketMarker) {

				if ('region' in marketMapOptions && marketMapOptions.region) {

					marketMarker.pin.addListener('mouseover', function() {
            // marketMarker.clickOpen = true;

            // marketMarkerOpen(marketMarker, true);
					  // marketMarker.pin.trigger('click');
						//marketMarkerOpen(marketMarker, true);
					});

					marketMarker.pin.addListener('mouseout', function() {

						if (!('clickOpen' in marketMarker) || !marketMarker.clickOpen) {
							marketMarker.window.close();
							marketMarkerChangeIcon(marketMarker, marketMarker.icon);
						}

					});

				}

				marketMarker.pin.addListener('click', function() {
					marketMarker.clickOpen = true;

					marketMarkerOpen(marketMarker, true);
				});

				marketMarker.window.addListener('closeclick', function() {
					marketMarker.clickOpen = false;
					marketMarkerChangeIcon(marketMarker, marketMarker.icon);
				});

			}

		});

		function marketMarkerOpen(marketMarker, enableScrollMarket) {
			enableScrollMarket = enableScrollMarket || false;

			if (typeof marketMarkerActive !== 'undefined') {
				marketMarkerActive.window.close();

				marketMarkerChangeIcon(marketMarkerActive, marketMarkerActive.icon);
			}

			if (marketMarker.window.content.indexOf('data-src') !== -1) {

				marketMarker.window.setContent(
					marketMarker.window.content.replace('data-src', 'src')
				);

			}

			marketMarker.window.open({
				anchor: marketMarker.pin,
				map: marketMap,
				shouldFocus: false,
			});

			marketMarkerChangeIcon(marketMarker, 1);

			marketMarkerActive = marketMarker;

			if (enableScrollMarket) {
				// scroll to market in list
			}

			google.maps.event.addListener(marketMarker.window, 'domready', function() {

				var $gallery = $('.gm-style-iw-d').find('.jq-market-gallery');

				if ($gallery.length) {

					marketsGalleryState($gallery);

				}

			});
		}

		function marketMarkerChangeIcon(marketMarker, icon) {
			if ('icons' in marketMapOptions && marketMapOptions.icons[icon]) {
			  if(icon==0 && typeof marketMarker.pin.extra_icon !== 'undefined'){
          marketMarker.pin.setIcon(marketMarker.pin.extra_icon);
        }else{
          marketMarker.pin.setIcon(marketMapOptions.icons[icon]);
        }

			}
		};

	};

	window.marketsMap = marketsMap;

	marketsInit();

})(jQuery);
